"use client";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Heart, Loader2 } from "lucide-react";

interface WishlistButtonProps {
  gameId: string;
  isWishlisted: boolean;
  isLoading: boolean;
  onToggle: (gameId: string) => Promise<void>;
  className?: string;
}

export function WishlistButton({
  gameId,
  isWishlisted,
  isLoading,
  onToggle,
  className,
}: WishlistButtonProps) {
  return (
    <Button
      variant="outline"
      size="icon"
      onClick={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await onToggle(gameId);
      }}
      disabled={isLoading}
      className={cn(
        "size-8 md:size-12 bg-white/5 glass-button-border backdrop-blur-[20px] border-0 hover:bg-black/80",
        className,
      )}
      aria-label={isWishlisted ? "Unfollow game" : "Follow game"}
    >
      {isLoading ? (
        <Loader2 className="size-4 md:size-6 animate-spin text-white" />
      ) : (
        <Heart
          className="size-4 md:size-6 text-white"
          fill={isWishlisted ? "currentColor" : "none"}
        />
      )}
    </Button>
  );
}
